import {useCallback, useEffect, useState} from 'react';

const useParallax = () => {
    const [scrollY, setScrollY] = useState(0);
    const [windowHeight, setWindowHeight] = useState(0);

    const handleScroll = useCallback(() => {
        requestAnimationFrame(() => {
            setScrollY(window.pageYOffset);
        });
    }, []);

    const handleResize = useCallback(() => {
        setWindowHeight(window.innerHeight);
    }, []);

    useEffect(() => {
        setWindowHeight(window.innerHeight);

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [handleScroll, handleResize]);

    // Возвращаем различные скорости для разных элементов
    return {
        scrollY,
        windowHeight,
        // Медленный параллакс для фона
        bgParallax: scrollY * 0.3,
        // Средний параллакс для основных элементов
        midParallax: scrollY * 0.5,
        // Быстрый параллакс для переднего плана
        fastParallax: scrollY * 0.7,
        // Обратный параллакс (движение вверх при скролле вниз)
        reverseParallax: scrollY * -0.2,
        // Процент прокрутки первого экрана
        scrollProgress: Math.min(scrollY / windowHeight, 1)
    };
};

export default useParallax;